import { render, staticRenderFns } from "./QuickFontSettings.vue?vue&type=template&id=2a30833c&scoped=true"
import script from "./QuickFontSettings.vue?vue&type=script&lang=js"
export * from "./QuickFontSettings.vue?vue&type=script&lang=js"
import style0 from "./QuickFontSettings.vue?vue&type=style&index=0&id=2a30833c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30833c",
  null
  
)

export default component.exports